//An extract of address points from the LINZ bulk extract: http://www.linz.govt.nz/survey-titles/landonline-data/landonline-bde
//Should be this data set: http://data.linz.govt.nz/#/layer/779-nz-street-address-electoral/
export const addressPoints = [
    [27.0238,74.2179, "10000"],
    [97.02238,74.22179, "10000"],
  ];
  


// WEBPACK FOOTER //
// ./src/views/Dashboard/realworld.1000.js